import { CrossBorderPaymentActionType } from './actions';
import { crossBorderPaymentInitialState } from './state';
const reducer = (state, action) => {
    switch (action.type) {
        case CrossBorderPaymentActionType.FROM_ACCOUNT_SELECTED:
            return {
                ...state,
                fromAccount: action.payload,
            };
        case CrossBorderPaymentActionType.TO_ACCOUNT_SELECTED:
            return {
                ...state,
                receiver: action.payload,
                currency: undefined,
                newReceiver: false,
            };
        case CrossBorderPaymentActionType.AMOUNT:
            return {
                ...state,
                amount: action.payload,
            };
        case CrossBorderPaymentActionType.CURRENCY:
            return {
                ...state,
                currency: action.payload,
            };
        case CrossBorderPaymentActionType.TRANSFER_CURRENCY:
            return {
                ...state,
                transferCurrency: action.payload,
            };
        case CrossBorderPaymentActionType.PAYMENT_DATE:
            return {
                ...state,
                paymentDate: action.payload,
            };
        case CrossBorderPaymentActionType.MESSAGE_RECEIVER:
            return {
                ...state,
                messageReceiver: action.payload,
            };
        case CrossBorderPaymentActionType.FIRST_BANKING_DATE_FROM_TODAY:
            return {
                ...state,
                firstBankingDateFromToday: action.payload,
            };
        case CrossBorderPaymentActionType.SET_PAYMENT_DESCRIPTION:
            return {
                ...state,
                paymentDescription: action.payload,
            };
        case CrossBorderPaymentActionType.SET_REGULATORY_CODE:
            return {
                ...state,
                regulatoryCode: action.payload,
            };
        case CrossBorderPaymentActionType.SET_COUNTRY_INFO:
            return {
                ...state,
                chargeBearer: 'SHARED',
                country: action.payload,
                bankValidation: undefined,
                receiver: {
                    bankCountryCode: state.receiver?.bankCountryCode,
                    name: undefined,
                    accountNumber: undefined,
                    accountType: undefined,
                    address: undefined,
                    postcode: undefined,
                    town: undefined,
                    receiverCountryCode: undefined,
                    nationalId: undefined,
                    bic: undefined,
                },
                amount: undefined,
                amountInNok: undefined,
                currency: undefined,
            };
        case CrossBorderPaymentActionType.SET_CHOSEN_RECEIVER:
            return {
                ...state,
                chosenReceiver: action.payload,
            };
        case CrossBorderPaymentActionType.SET_RECEIVER_COUNTRY_INFO:
            return {
                ...state,
                country: action.payload,
            };
        case CrossBorderPaymentActionType.SET_RECEIVER_NAME:
            return {
                ...state,
                receiverName: action.payload,
            };
        case CrossBorderPaymentActionType.UPDATE_RECEIVER_NAME:
            return {
                ...state,
                receiver: {
                    ...state.receiver,
                    name: action.payload,
                },
            };
        case CrossBorderPaymentActionType.SET_RECEIVER_ACCOUNT_NUMBER:
            return {
                ...state,
                receiver: {
                    ...state.receiver,
                    accountNumber: action.payload,
                },
            };
        case CrossBorderPaymentActionType.SET_RECEIVER_ADDRESS:
            return {
                ...state,
                receiver: {
                    ...state.receiver,
                    address: action.payload,
                },
            };
        case CrossBorderPaymentActionType.SET_RECEIVER_ADDRESS_2:
            return {
                ...state,
                receiver: {
                    ...state.receiver,
                    address2: action.payload,
                },
            };
        case CrossBorderPaymentActionType.SET_RECEIVER_POSTCODE:
            return {
                ...state,
                receiver: {
                    ...state.receiver,
                    postcode: action.payload,
                },
            };
        case CrossBorderPaymentActionType.SET_RECEIVER_TOWN:
            return {
                ...state,
                receiver: {
                    ...state.receiver,
                    town: action.payload,
                },
            };
        case CrossBorderPaymentActionType.SET_RECEIVER_COUNTRY:
            return {
                ...state,
                receiver: {
                    ...state.receiver,
                    receiverCountryCode: action.payload,
                },
            };
        case CrossBorderPaymentActionType.SET_RECEIVER_ACCOUNT_TYPE:
            return {
                ...state,
                receiver: {
                    ...state.receiver,
                    accountType: action.payload,
                },
            };
        case CrossBorderPaymentActionType.SET_BANK_VALIDATION:
            return {
                ...state,
                bankValidation: action.payload,
            };
        case CrossBorderPaymentActionType.SET_BANK_COUNTRY:
            return {
                ...state,
                receiver: {
                    ...state.receiver,
                    bankCountryCode: action.payload,
                },
            };
        case CrossBorderPaymentActionType.SET_RECEIVER_NATIONAL_ID:
            return {
                ...state,
                receiver: {
                    ...state.receiver,
                    nationalId: action.payload,
                },
            };
        case CrossBorderPaymentActionType.SET_RECEIVER_BIC:
            return {
                ...state,
                receiver: {
                    ...state.receiver,
                    bic: action.payload,
                },
            };
        case CrossBorderPaymentActionType.RESET_RECEIVER:
            return {
                ...state,
                receiver: undefined,
                bankValidation: undefined,
                country: undefined,
                newReceiver: true,
            };
        case CrossBorderPaymentActionType.RESET_BANK_VALIDATION:
            return {
                ...state,
                bankValidation: undefined,
                receiver: {
                    ...state.receiver,
                    accountType: undefined,
                    nationalId: undefined,
                    bic: undefined,
                    needBic: false,
                },
            };
        case CrossBorderPaymentActionType.SET_AMOUNT_IN_NOK:
            return {
                ...state,
                amountInNok: action.payload,
            };
        case CrossBorderPaymentActionType.SET_NEED_BIC:
            return {
                ...state,
                receiver: {
                    ...state.receiver,
                    needBic: true,
                },
            };
        case CrossBorderPaymentActionType.SET_BANK_VALIDATION_OPTION:
            return {
                ...state,
                receiver: {
                    ...state.receiver,
                    bankValidationOption: action.payload,
                },
            };
        case CrossBorderPaymentActionType.SET_CHARGE_BEARER:
            return {
                ...state,
                chargeBearer: action.payload,
            };
        case CrossBorderPaymentActionType.SET_PRIORITY:
            return {
                ...state,
                priority: action.payload,
            };
        case CrossBorderPaymentActionType.RESET:
            return {
                ...crossBorderPaymentInitialState,
            };
        default:
            return state;
    }
};
const crossBorderPaymentReducer = (state, action) => {
    const newState = reducer(state, action);
    if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('%cPayment form', 'color: green; font-weight: bold', action, 'new state', newState);
    }
    return newState;
};
export default crossBorderPaymentReducer;
//# sourceMappingURL=data:application/json;base64,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